<template>
    <div id="investment-opportunities">
        <!--=====================================-->
        <!--=        Counter Up Area Start      =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="section-heading heading-light">
                    <span class="subtitle primary">Oportunidades de inversión</span>
                    <h2 class="font-weight-100 mb--20">Nuestras <span class="bold">semillas</span>.</h2>
                </div>
            </div>
        </section>

        <!--=====================================-->
        <!--=       Recent Post Area Start      =-->
        <!--=====================================-->
        <section class="section related-blog-area">
            <div class="container">
                <slick v-if="isMounted" :options="slickOptions">
                       <div v-for="(project, index) in projects" class="slick-slide">
                        <SeedCard 
                            :key="index" 
                            :isRed="(project.programInfo !== null)" 
                            :project="project" />
                    </div>
                </slick>
            </div>
        </section>
    </div>
</template>

<script>
import SeedCard from './partials/seed-card.vue';
import ButtonCard from './partials/button-card.vue';
import Slick from 'vue-slick';
export default {
    name: "InvestmentOpportunities",
    components: {
        SeedCard,
        ButtonCard,
        Slick
    },
    data() {
        return {
            loading: false,
            projects: [],
            user: '',
            boxInvert: false,
            sunflowers: [],
            loading_sunflowers: false,
            isMounted: false,
            slickOptions: {
                infinite: true,
                autoplay: true,
                arrows: false,
                dots: true,
                slidesToShow: 3,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            }
        }
    },
    async mounted() {
        this.isMounted = false;
        await this.getFundingProjects();
        this.$forceUpdate();
        this.isMounted = true;
    },
    methods: {
        async getFundingProjects() {
            try {
                const response = await this.publicApiGet('/api/v1/public_stats/getFundingProjects');
                this.projects = response.data;
                // console.log(this.projects);
                await this.orderProjects();
                this.isMounted = true;
            } catch (e) { }
        },
        orderProjects() {
            let project_priority = [];

            this.projects.sort(function (a, b) {
                return (((b.invested / (b.financed_amount)) * 100).toFixed(0) - ((a.invested / (a.financed_amount)) * 100)
                    .toFixed(0));
            });
            project_priority = this.projects.filter(function (prj) {
                return prj.public_top === 1
            });
            if (project_priority != undefined && project_priority.length > 0) {
                this.projects = this.projects.filter(function (ele) {
                    return ele.public_top !== 1;
                });

                project_priority.sort(function (a, b) {
                    return (((a.invested / (a.financed_amount)) * 100).toFixed(0) - ((b.invested / (b.financed_amount)) *
                        100).toFixed(0));
                });
                for (var i = 0; i < project_priority.length; i++) {
                    this.projects.unshift(project_priority[i])
                }

            }
        },
    }
}

</script>

<style scoped>
.slick-slide {
    padding-left: 2rem !important;
    padding-right: 2rem !important;
}

.fix-float-card {
    width: 24rem;
    float: right;
    margin-right: 3rem;
}

@media only screen and (max-width: 991px) {
    .fix-float-card {
        display: none;
    }
}
</style>